import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { LoginRequest, LoginResponse } from "./Authentication.constants";
import axiosInstance from "../../shared/service/axios";

export const useAuthenticationLoginMutation = (): UseMutationResult<
  LoginResponse,
  AxiosError,
  LoginRequest
> =>
  useMutation<LoginResponse, AxiosError, LoginRequest>(
    async (requestValues: LoginRequest) => {
      const { data } = await axiosInstance.post("auth/login/", requestValues);

      return data;
    }
  );
